<div class="window-dialog-shell" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="window-dialog-title" mat-dialog-title cdkDragHandle>
    <span>{{ data.title }}</span>

    <span class="window-dialog-title-spacer"></span>

    <button
      mat-icon-button
      (click)="toggleMaximize(); $event.stopPropagation()"
    >
      <mat-icon class="material-symbols-outlined">{{
        maximized ? "fullscreen_exit" : "fullscreen"
      }}</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="window-dialog-content">
    <cl-image-upload-content
      [selectedPanel]="panelOpen"
      [signature]="signature"
      [taskID]="taskID"
      [builder]="builder"
      [checklist]="checklist"
      [number]="number"
      [editor]="editor"
      [roleIds]="roleIds"
      [enableColumnsBuilder]="enableColumnsBuilder ?? false"
      [disabled]="disabled"
      [configuration]="configuration"
      (changed)="changed($event)"
      [date]="date"
      [saving]="saving ?? false"
      [checklistTemplate]="checklistTemplate"
    >
    </cl-image-upload-content>
  </mat-dialog-content>
  <mat-dialog-actions
    align="center"
    class="window-dialog-actions d-flex full-width justify-content-between"
  >
    <button mat-stroked-button color="warn" type="button" (click)="close()">
      {{ isFormDirty() ? "Cancel" : "Close" }}
    </button>
    <div class="d-flex justify-content-center align-items-center">
      <button
        mat-icon-button
        class="blue"
        [ngClass]="{ 'blue-bg': panelOpen == panel.Image }"
        matTooltip="View Images"
        [disabled]="panelOpen == panel.Image"
        (click)="selectPanel(panel.Image)"
      >
        <mat-icon>image</mat-icon>
      </button>
      <button
        mat-icon-button
        class="yellow"
        [ngClass]="{ 'yellow-bg': panelOpen == panel.Table }"
        matTooltip="View Data"
        [disabled]="panelOpen == panel.Table"
        (click)="selectPanel(panel.Table)"
      >
        <mat-icon class="material-symbols-outlined">table</mat-icon>
      </button>
      <button
        mat-icon-button
        class="orange"
        [ngClass]="{ 'orange-bg': panelOpen == panel.History }"
        matTooltip="View History"
        [disabled]="panelOpen == panel.History"
        (click)="selectPanel(panel.History)"
      >
        <mat-icon>history</mat-icon>
      </button>
    </div>

    <button
      mat-flat-button
      color="primary"
      type="button"
      class="save-button"
      [disabled]="!isFormDirty()"
      (click)="save()"
    >
      Save
    </button>
  </mat-dialog-actions>
</div>
